<template>
  <v-row justify="center">
    <v-dialog v-model="authAttemptDialog" scrollable max-width="1030px">
      <v-card>
        <v-card-title>분실 알림 SMS 설정</v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 590px;" class="pb-0">
          <p class="mb-0 font-weight-bold body-1 mt-9 mb-3 black--text">
            카페24 SMS 문자 서비스를 통해 발송됩니다
          </p>
          <p class="mb-0 body-2 text-truncate mt-0">
            <font
              >아래의 설정을 통해 분실등록/분실취소로 인증 상태를
              변경하거나</font
            >
          </p>
          <p class="mb-0 body-2 text-truncate mt-0">
            <font>
              분실 상태의 상품이 다른 누군가가 인증 시도할때 분실 요청한
              회원님에게 SMS 알림 서비스를 제공할 수 있습니다.
            </font>
          </p>
          <p class="mb-0 caption text-truncate mt-0">
            <font class="blue--text">
              ※ 카페24 SMS 사용설정에 '사용함'으로 설정되어 있어야 사용이
              가능합니다
            </font>
          </p>

          <v-row class="pt-5">
            <v-col class="pt-0 pb-0">
              <font class="font-weight-bold body-2 black--text"
                >* SMS 발송 설정</font
              >
            </v-col>
          </v-row>
          <v-row cols="12">
            <v-col class="pt-5 pb-0 col-4">
              <v-select
                v-model="config.sender_no"
                :items="sendNumberList"
                label="발신번호 선택"
                class="pt-0 body-2"
                dense
              ></v-select>
            </v-col>
            <v-col class="pt-5 pb-0 col-4">
              <v-select
                v-model="config.unsubscriber"
                :items="notAcceptSendUseList"
                label="수신거부자 발송 여부"
                class="pt-0 body-2"
                dense
              ></v-select>
            </v-col>
            <v-col class="pt-5 pb-0 col-4">
              <v-select
                v-model="config.sms_type"
                :items="byteOverSendKindList"
                label="90byte 초과시 단문/장문 발송 선택"
                class="pt-0 body-2"
                dense
                @change="smsTypeChange()"
              ></v-select>
            </v-col>
          </v-row>

          <v-row class="pt-2">
            <v-col class="pt-0 pb-0">
              <font class="font-weight-bold body-2 black--text"
                >* 분실 상태로 변경시 발송</font
              >
            </v-col>
            <v-col class="pt-0 pb-0">
              <font class="font-weight-bold body-2 black--text"
                >* 분실취소 상태로 변경시 발송</font
              >
            </v-col>
            <v-col class="pt-0 pb-0">
              <font class="font-weight-bold body-2 black--text"
                >* 분실 상품을 제3자 인증 시도시 발송</font
              >
            </v-col>
          </v-row>

          <v-row class="pt-4" cols="12" style="height: 50px;">
            <v-col class="pt-0 pb-0 col-4">
              <v-select
                v-model="config.change_lost"
                :items="lostAlarmUseList"
                label="알림 사용여부"
                persistent-hint
                class="pt-0 body-2"
                outlined
                dense
                @change="changeLost"
              ></v-select>
            </v-col>
            <v-col class="pt-0 pb-0 col-4">
              <v-select
                v-model="config.cancel_lost"
                :items="lostCancelAlarmUseList"
                label="알림 사용여부"
                persistent-hint
                class="pt-0 body-2"
                outlined
                dense
                @change="cancelLost"
              ></v-select>
            </v-col>
            <v-col class="pt-0 pb-0 col-4">
              <v-select
                v-model="config.activate_lost"
                :items="lostAttemptAlarmUseList"
                label="알림 사용여부"
                persistent-hint
                class="pt-0 body-2"
                outlined
                dense
                @change="activateLost"
              ></v-select>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-textarea
                :counter-value="lostTextCounterValue"
                counter
                outlined
                no-resize
                style="font-size:13px;"
                v-model="config.change_lost_message"
                :disabled="change_lost_disabled"
              ></v-textarea>
            </v-col>
            <v-col>
              <v-textarea
                :counter-value="cancelTextCounterValue"
                counter
                outlined
                no-resize
                style="font-size:13px;"
                v-model="config.cancel_lost_message"
                :disabled="change_cancel_disabled"
              ></v-textarea>
            </v-col>
            <v-col>
              <v-textarea
                :counter-value="activateTextCounterValue"
                counter
                outlined
                no-resize
                style="font-size:13px;height:200px;"
                v-model="config.activate_lost_message"
                :disabled="activate_lost_disabled"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="authAttemptDialog = false"
            >닫기</v-btn
          >
          <v-btn color="blue darken-1" text @click.prevent="saveConfig"
            >저장</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<style>
textarea {
  line-height: 1.6 !important;
  height: 200px;
}
</style>
<script>
import M from "@/libs/mapping.js";
import CommonMixin from "@/mixins/CommonMixin.js";

export default {
  data() {
    return {
      authAttemptDialog: false,
      lostAlarmUseList: [
        { text: "사용함", value: "enabled" },
        { text: "사용안함", value: "disabled" },
      ],
      lostCancelAlarmUseList: [
        { text: "사용함", value: "enabled" },
        { text: "사용안함", value: "disabled" },
      ],
      lostAttemptAlarmUseList: [
        { text: "사용함", value: "enabled" },
        { text: "사용안함", value: "disabled" },
      ],
      notAcceptSendUseList: [
        { text: "발송함", value: "include" },
        { text: "발송안함", value: "exclude" },
      ],
      byteOverSendKindList: [
        { text: "SMS 단문 (90 byte 초과시 여러개 발송)", value: "sms" },
        { text: "LMS 장문 (2000 byte까지 한번에 발송)", value: "lms" },
      ],
      sendNumberList: [],
      config: {},
      byteType: "",
      change_lost_disabled: false,
      change_cancel_disabled: false,
      activate_lost_disabled: false,
    };
  },
  mixins: [CommonMixin],
  methods: {
    lostNotificationSmsSetting: async function() {
      let data = await M.api(M.entry("/get/config/sms"));
      this.config = data.config;
      for (let key in this.config) {
        if (!this.config[key]) {
          this.config[key] = "enabled";
          if (key == "sms_type") {
            this.config[key] = "lms";
          }
          if (key == "unsubscriber") {
            this.config[key] = "exclude";
          }
        }
      }

      if (
        !data.config.change_lost_message ||
        data.config.change_lost_message == "enabled"
      ) {
        this.config.change_lost_message = `[[정품인증코드]]\n분실상태로 변경되었습니다.\n다른 사용자가 정품 인증을 할 수 없으며\n분실된 제품을 다른 사용자가 정품인증을시도하는 경우 관리자가 확인이 가능합니다.\n제품을 찾으시면 분실 취소로 변경하시어 보증기간 및 혜택을 받으시길 권장합니다.\n감사합니다.`;
      }

      if (
        !data.config.cancel_lost_message ||
        data.config.cancel_lost_message == "enabled"
      ) {
        this.config.cancel_lost_message = `[[정품인증코드]]\n분실된 제품을 잘 찾으셨나요?\n해당 제품은 정상적인 정품 인증 상태로 변경되었습니다.\n제품에 대한 보증기간 및 혜택을 받으실 수 있습니다.\n감사합니다.`;
      }

      if (
        !data.config.activate_lost_message ||
        data.config.activate_lost_message == "enabled"
      ) {
        this.config.activate_lost_message = `[[정품인증코드]]\n제3자가 분실 제품 인증을 시도하였습니다.\n관리자 확인하여 안내드리도록 하겠습니다.\n감사합니다.`;
      }

      if (data.senders.length > 0) {
        data.senders.forEach((sender) => {
          this.sendNumberList.push({
            text: sender.sender,
            value: sender.sender_no,
          });
        });
      }

      if (data.config.sms_type == "sms") {
        this.byteType = " / 90byte";
      } else if (data.config.sms_type == "lms") {
        this.byteType = " / 2000byte";
      } else {
        this.byteType = "";
      }

      this.authAttemptDialog = true;

      if (this.config.activate_lost != "enabled") {
        this.activate_lost_disabled = true;
      }
      if (this.config.cancel_lost != "enabled") {
        this.change_cancel_disabled = true;
      }
      if (this.config.change_lost != "enabled") {
        this.change_lost_disabled = true;
      }
    },
    lostTextCounterValue: function() {
      return (
        this.textCounterValue(this.config.change_lost_message) + this.byteType
      );
    },
    cancelTextCounterValue: function() {
      return (
        this.textCounterValue(this.config.cancel_lost_message) + this.byteType
      );
    },
    activateTextCounterValue: function() {
      return (
        this.textCounterValue(this.config.activate_lost_message) + this.byteType
      );
    },
    textCounterValue: function(str) {
      var utf8length = 0;
      for (var n = 0; n < str.length; n++) {
        var c = str.charCodeAt(n);
        if (c < 128) {
          utf8length++;
        } else if (c > 127 && c < 2048) {
          utf8length = utf8length + 2;
        } else {
          utf8length = utf8length + 3;
        }
      }
      return utf8length + " byte";
    },
    saveConfig: async function() {
      if (this.config.change_lost === "") {
        this.alertShow("분실 등록시 알림 사용여부를 선택하세요");
        return false;
      }
      if (this.config.cancel_lost === "") {
        this.alertShow("분실 취소시 알림 사용여부를 선택하세요");
        return false;
      }
      if (this.config.activate_lost === "") {
        this.alertShow("분실상품 인증 시도시 알림 사용여부를 선택하세요");
        return false;
      }
      if (this.config.sender_no === "") {
        this.alertShow("발신번호를 선택하세요");
        return false;
      }
      if (this.config.unsubscriber === "") {
        this.alertShow("수신거부자 발송 여부를 선택하세요");
        return false;
      }
      if (this.config.sms_type === "") {
        this.alertShow("90byte 초과시 단문/장문 발송을 선택하세요");
        return false;
      }
      await M.api(M.entry("/put/config/sms"), this.config);
      this.authAttemptDialog = false;
    },
    changeLost: function() {
      if (this.config.change_lost == "enabled") {
        this.change_lost_disabled = false;
      } else {
        this.change_lost_disabled = true;
      }
    },
    cancelLost: function() {
      if (this.config.cancel_lost == "enabled") {
        this.change_cancel_disabled = false;
      } else {
        this.change_cancel_disabled = true;
      }
    },
    activateLost: function() {
      if (this.config.activate_lost == "enabled") {
        this.activate_lost_disabled = false;
      } else {
        this.activate_lost_disabled = true;
      }
    },
    smsTypeChange: function() {
      if (this.config.sms_type == "sms") {
        this.byteType = " / 90byte";
      } else if (this.config.sms_type == "lms") {
        this.byteType = " / 2000byte";
      } else {
        this.byteType = "";
      }
    },
  },
};
</script>
